import {
  Align,
  Arrange,
  Container,
  Icon,
  Spacer,
  Text,
  Tooltip,
} from '@loomhq/lens';
import cn from 'classnames';
import React, { forwardRef, useContext } from 'react';
import { Link } from 'react-router';

import { useShareWithMeFTUXTooltipState } from 'utilities/localStorage/ftux';

import { DestinationContext } from 'contexts/DestinationContext';

import { FadeRoot, FadeText } from './FadeText';

import FTUXTooltip from 'components/ftux-tooltip';

import styles from './styles.module.less';

const MenuIcon = ({ collapsed, icon, count }) => {
  return (
    <>
      {collapsed && count > 0 && (
        <div className={styles.bubble}>
          <Container backgroundColor="record" height="small" width="small" />
        </div>
      )}
      <Icon icon={icon} color="currentColor" />
    </>
  );
};

const MenuLink = forwardRef(
  (
    {
      title,
      url,
      icon,
      collapsed,
      count,
      shouldShowFTUXTooltip,
      onClick,
      isReactRouterLink,
      shouldDim,
      className,
      actionElement,
    },
    ref
  ) => {
    const isActive = (window.location.pathname + '/').startsWith(url + '/');
    const [, dismissTooltip] = useShareWithMeFTUXTooltipState();
    const isInDestinationRoute = useContext(DestinationContext);

    const linkProps = {
      ref,
      className: cn(
        styles.menuItem,
        shouldShowFTUXTooltip && styles.hasFTUXTooltip,
        shouldDim && styles.shouldDim,
        className
      ),
      'aria-current': isActive ? 'page' : undefined,
      onClick,
      children: (
        <Arrange justifyContent="space-between">
          <FadeRoot className={styles.menuItemInner}>
            {icon && (
              <MenuIcon icon={icon} count={count} collapsed={collapsed} />
            )}
            <Spacer right="small" />
            <FadeText visible={!collapsed}>
              <Text className={styles.linkTitle} hasEllipsis>
                {title}
              </Text>
            </FadeText>
          </FadeRoot>
          {!collapsed && count > 0 && (
            <div className={styles.count}>
              <Container
                backgroundColor="record"
                minWidth="large"
                height="large"
                paddingX="small"
              >
                <Align alignment="center">
                  <Text color="white" fontWeight="medium">
                    {count >= 99 ? '99+' : count}
                  </Text>
                </Align>
              </Container>
            </div>
          )}
          {!collapsed && actionElement}
        </Arrange>
      ),
    };

    const content =
      isReactRouterLink && isInDestinationRoute ? (
        <Link {...linkProps} to={url} />
      ) : (
        <a {...linkProps} href={url} />
      );

    return shouldShowFTUXTooltip && !isActive ? (
      <>
        <FTUXTooltip
          variant={
            collapsed ? 'tooltipOnCollapsedNavBar' : 'tooltipOnExpandedNavBar'
          }
          title="New sharing features!"
          subtitle={
            <>
              No more losing Looms! Keep track of videos you have been added to
              in your <b>Shared with me space.</b>
            </>
          }
          dismissTooltip={dismissTooltip}
        />
        {content}
      </>
    ) : (
      <Tooltip
        content={collapsed ? title : null}
        isInline={false}
        placement="rightCenter"
      >
        {content}
      </Tooltip>
    );
  }
);

export default MenuLink;
